import { Input, Label } from './Checkbox.styles';
import type { CheckboxProps } from './Checkbox.types';

export function Checkbox({
  checked,
  onChange,
  label,
  disabled,
  error,
  indeterminate,
  'aria-label': ariaLabel,
  'aria-expanded': ariaExpanded,
  'aria-controls': ariaControls,
}: CheckboxProps) {
  return (
    <Label data-disabled={disabled}>
      <Input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        data-error={error}
        data-indeterminate={indeterminate}
        aria-invalid={error}
        aria-checked={indeterminate ? 'mixed' : checked}
        aria-label={ariaLabel}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
      />
      {label}
    </Label>
  );
}
